<script>
import {
  addResizeListener,
  removeResizeListener,
} from "element-ui/src/utils/resize-event";

const firstUpperCase = (str) => {
  return str.toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase());
};

export default {
  name: "ScrollView",

  props: {},

  data() {
    return {
      scrollable: false,
      navOffset: 0,
      height: 0,
    };
  },

  computed: {
    navStyle() {
      // const dir = "X";
      // return {
      //   transform: `translate${dir}(-${this.navOffset}px)`,
      // };
      try {
        const navScroll = this.$refs.navScroll;
        if (navScroll) {
          navScroll.scrollTo({
            top: 0,
            left: navScroll.scrollLeft + this.navOffset,
            behavior: "smooth",
          });
        }
      } catch (error) {
        console.log(error);
      }

      return {
        custom: this.navOffset,
        transform: 0,
      };
    },
    sizeName() {
      return "width";
    },
  },

  methods: {
    scrollPrev() {
      const containerSize = this.$refs.navScroll[
        `offset${firstUpperCase(this.sizeName)}`
      ];
      const currentOffset = this.navOffset;

      if (!currentOffset) return;

      let newOffset =
        currentOffset > containerSize ? currentOffset - containerSize : 0;

      this.navOffset = newOffset;
      this.navOffset = -containerSize;
    },
    scrollNext() {
      const navSize = this.$refs.nav[`offset${firstUpperCase(this.sizeName)}`];
      const containerSize = this.$refs.navScroll[
        `offset${firstUpperCase(this.sizeName)}`
      ];
      const currentOffset = this.navOffset;

      if (navSize - currentOffset <= containerSize) return;

      let newOffset =
        navSize - currentOffset > containerSize * 2
          ? currentOffset + containerSize
          : navSize - containerSize;

      this.navOffset = newOffset;
      this.navOffset = containerSize;
    },
    scrollToActiveTab() {
      if (!this.scrollable) return;
      const nav = this.$refs.nav;
      const activeTab = this.$el.querySelector(".is-active");
      if (!activeTab) return;
      const navScroll = this.$refs.navScroll;
      const activeTabBounding = activeTab.getBoundingClientRect();
      const navScrollBounding = navScroll.getBoundingClientRect();
      const maxOffset = nav.offsetWidth - navScrollBounding.width;
      const currentOffset = this.navOffset;
      let newOffset = currentOffset;

      if (activeTabBounding.left < navScrollBounding.left) {
        newOffset =
          currentOffset - (navScrollBounding.left - activeTabBounding.left);
      }
      if (activeTabBounding.right > navScrollBounding.right) {
        newOffset =
          currentOffset + activeTabBounding.right - navScrollBounding.right;
      }
      newOffset = Math.max(newOffset, 0);
      this.navOffset = Math.min(newOffset, maxOffset);
    },
    update() {
      if (!this.$refs.nav) return;
      const sizeName = this.sizeName;
      const navSize = this.$refs.nav[`offset${firstUpperCase(sizeName)}`];
      this.height = this.$refs.nav.offsetHeight;
      const containerSize = this.$refs.navScroll[
        `offset${firstUpperCase(sizeName)}`
      ];
      const currentOffset = this.navOffset;

      if (containerSize < navSize) {
        const currentOffset = this.navOffset;
        this.scrollable = this.scrollable || {};
        this.scrollable.prev = currentOffset;
        this.scrollable.next = currentOffset + containerSize < navSize;
        if (navSize - currentOffset < containerSize) {
          this.navOffset = navSize - containerSize;
        }
      } else {
        this.scrollable = false;
        if (currentOffset > 0) {
          this.navOffset = 0;
        }
      }
    },
  },

  updated() {
    this.update();
  },

  render() {
    const { navStyle, scrollable, scrollNext, scrollPrev, height } = this;
    const lineHeight = {
      "line-height": height + "px",
    };
    const scrollBtn = scrollable
      ? [
          <span
            class={[
              "scroll-view__nav-prev",
              scrollable.prev ? "" : "is-disabled",
            ]}
            style={lineHeight}
            on-click={scrollPrev}
          >
            <i class="el-icon-arrow-left"></i>
          </span>,
          <span
            class={[
              "scroll-view__nav-next",
              scrollable.next ? "" : "is-disabled",
            ]}
            style={lineHeight}
            on-click={scrollNext}
          >
            <i class="el-icon-arrow-right"></i>
          </span>,
        ]
      : null;

    return (
      <div class={["scroll-view__nav-wrap", scrollable ? "is-scrollable" : ""]}>
        {scrollBtn}
        <div class={["scroll-view__nav-scroll"]} ref="navScroll">
          <div class={["scroll-view__nav"]} ref="nav" style={navStyle}>
            {this.$slots.default}
          </div>
        </div>
      </div>
    );
  },

  mounted() {
    addResizeListener(this.$el, this.update);
    setTimeout(() => {
      this.scrollToActiveTab();
    }, 0);
  },

  beforeDestroy() {
    if (this.$el && this.update) removeResizeListener(this.$el, this.update);
  },
};
</script>

<style lang="scss">
.scroll-view__nav-wrap {
  display: inline-block;
  vertical-align: middle;

  overflow: hidden;
  margin-bottom: -1px;
  position: relative;
}

.scroll-view__nav-wrap.is-scrollable {
  padding: 0 20px;
  box-sizing: border-box;
}

.scroll-view__nav-wrap::after {
  display: none;
}

.scroll-view__nav-scroll {
  // overflow: hidden;
  overflow: auto;
}

.scroll-view__nav {
  white-space: nowrap;
  position: relative;
  transition: transform 0.3s;
  float: left;
  z-index: 2;
}

.scroll-view__nav-prev {
  left: 4px;
}
.scroll-view__nav-next {
  right: 4px;
}
.scroll-view__nav-next,
.scroll-view__nav-prev {
  position: absolute;
  cursor: pointer;
  line-height: 44px;
  font-size: 12px;
  color: inherit;
}
</style>
